// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1FzEc","field":"styles_field__3krAy","fieldCol":"styles_fieldCol__2uSpI","diffCol":"styles_diffCol__1rlQ3","diff":"styles_diff__2-lg9"};